function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "v-card");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 3h-18c-0.553 0-1 0.447-1 1v12c0 0.552 0.447 1 1 1h18c0.553 0 1-0.448 1-1v-12c0-0.552-0.447-1-1-1zM13 7h4v1h-4v-1zM11 14.803c-0.129-0.102-0.293-0.201-0.529-0.303-1.18-0.508-2.961-1.26-2.961-2.176 0-0.551 0.359-0.371 0.518-1.379 0.066-0.418 0.385-0.007 0.445-0.961 0-0.38-0.174-0.475-0.174-0.475s0.088-0.562 0.123-0.996c0.036-0.453-0.221-1.8-1.277-2.097-0.186-0.188-0.311-0.111 0.258-0.412-1.244-0.059-1.534 0.592-2.196 1.071-0.564 0.42-0.717 1.085-0.689 1.439 0.037 0.433 0.125 0.996 0.125 0.996s-0.175 0.094-0.175 0.474c0.061 0.954 0.38 0.543 0.445 0.961 0.158 1.008 0.519 0.828 0.519 1.379 0 0.916-1.781 1.668-2.961 2.176-0.203 0.088-0.349 0.173-0.471 0.26v-9.76h9v9.803zM18 11h-5v-1h5v1z"
});

var SvgVCard = function SvgVCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/v-card.c828b6a8.svg";
export { ForwardRef as ReactComponent };